const convertSlugToUpprecaseString = (slug) => {
  if (!slug) return '';
  if (typeof slug !== 'string' || !slug?.includes('-')) {
    throw new Error('Input must be a kebab-case string');
  }
  return slug?.toUpperCase()?.replaceAll('-', ' ')?.trim();
};

export default convertSlugToUpprecaseString;
